/**
 * App entry point
 * Istanzia Vue e tutti i componenti necassari
 * @module main
 */

import Vue from 'vue'
import App from '@/components/App.vue'
import Vuetify from 'vuetify'

import Auth from '@/auth'
import router from '@/router'
import store from '@/store'
import VueResource from 'vue-resource'
import VTooltip from 'v-tooltip'

import VueI18n from 'vue-i18n'
import veeIt from 'vee-validate/dist/locale/it'
import numberFormats from '@/i18n'
import messages from '@/i18n'
import VeeValidate from 'vee-validate'
import money from 'v-money'

import 'flag-icon-css/css/flag-icon.css'

import {
  DescrEditor,
  ProdEditor,
  ChipEditor,
  PriceEditor,
  Spinner,
  MenuEditor,
  ProdEditorFull,
  ProdSelector,
  BreadCrumbMenu,
  TavoloEditor,
  Loading,
  Lock,
  MainPriceChanger,
  AddToCart,
  ShowCart,
  ConfirmDelete,
  TooltipContainer,
  CombCreator,
  Changed,
  TerminalDialog,
  OperatorDialog,
  PaymentDialog,
  DiscountDialog,
  PrinterMapDialog
} from '@/components/common'

import Lib from '@/components/lib/Lib.vue'

import * as lodash from 'lodash'
import moment from 'moment'
import { extendMoment } from 'moment-range'
import utils from '@/utils'

import VueVirtualScroller from 'vue-virtual-scroller'

Vue.use(VueVirtualScroller)

import numeral from 'numeral'
import it from 'numeral/locales/it'
numeral.locale('it')

Vue.config.productionTip = false

Vue.use(VueI18n)
const i18n = new VueI18n({
  numberFormats,
  messages,
  locale: 'it'
})

Vue.use(VeeValidate, {
  i18nRootKey: 'validations',
  i18n,
  dictionary: {
    it: veeIt
  }
})

Vue.use(VueResource)
Vue.use(Vuetify)
Vue.use(Auth)
Vue.use(VTooltip)

Vue.use(money, { precision: 4 })

Vue.component('DescrEditor', DescrEditor)
Vue.component('ProdEditor', ProdEditor)
Vue.component('ChipEditor', ChipEditor)
Vue.component('PriceEditor', PriceEditor)
Vue.component('Spinner', Spinner)
Vue.component('Loading', Loading)
Vue.component('Lock', Lock)
Vue.component('Changed', Changed)
Vue.component('MenuEditor', MenuEditor)
Vue.component('ProdEditorFull', ProdEditorFull)
Vue.component('ProdSelector', ProdSelector)
Vue.component('BreadCrumbMenu', BreadCrumbMenu)
Vue.component('Lib', Lib)
Vue.component('TavoloEditor', TavoloEditor)
Vue.component('MainPriceChanger', MainPriceChanger)
Vue.component('AddToCart', AddToCart)
Vue.component('ShowCart', ShowCart)
Vue.component('ConfirmDelete', ConfirmDelete)
Vue.component('TooltipContainer', TooltipContainer)
Vue.component('CombCreator', CombCreator)
Vue.component('TerminalDialog', TerminalDialog)
Vue.component('OperatorDialog', OperatorDialog)
Vue.component('PaymentDialog', PaymentDialog)
Vue.component('DiscountDialog', DiscountDialog)
Vue.component('PrinterMapDialog', PrinterMapDialog)

/**
 * Oggetti presenti in window, (make the stuff below global)
 * <pre>
 * Vue
 * lodash
 * utils
 * moment
 * numeral
 * </pre>
 */
var vm = new Vue({
  el: '#app',
  created: function() {
    //Make the stuff below global
    window.Vue = this
    window._ = lodash
    window.utils = utils
    window.moment = extendMoment(moment)
    window.numeral = numeral
  },
  router,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js